import { FormikValues } from "formik/dist/types";
import { find } from "lodash";
import React from "react";
import { OrderCostingVersion, TApiOrderDetails } from "../../../api/endpoints/Order";
import { TApiServiceCharge } from "../../../api/endpoints/ServiceCharge";
import { TApiServicePackage } from "../../../api/endpoints/ServicePackage";
import { TApiVolumeBand } from "../../../api/endpoints/VolumeBand";
import ExternalLink from "../../Navigation/Links/ExternalLink";
import FormError from "../../RealtimeProductConfigurator/FormError";
import ServicePackagePicker from "../ServicePackagePicker";

interface Props {
  formik: FormikValues;
  order: TApiOrderDetails;
  volumeBand: TApiVolumeBand;
  serviceCharges: Array<TApiServiceCharge>;
  servicePackages: Array<TApiServicePackage>;
  onServicePackageChange: (servicePackage: TApiServicePackage) => void;
}

const SERVICE_CHARGE_DOCS_URL_MAP = {
  v1: null,
  v2: null,
  v3: {
    title: 'July 2022 - July 2024',
    url: 'https://confluence.ecmwf.int/display/DAC/Service+Charges%3A+01+July+2022+-+01+July+2024'
  },
  v4: {
    title: 'July 2024 onwards',
    url: 'https://confluence.ecmwf.int/display/DAC/Service+Charges%3A+From+01+July+2024'
  },
  v5: null,
  v6: null
}

const ServicePackageStep = (props: Props) => {
  const { formik,
    order,
    volumeBand,
    serviceCharges,
    servicePackages,
    onServicePackageChange
  } = props;

  const orderServicePackage = find(servicePackages, sp => sp.id === formik.values.service_package_id);
  const docs = SERVICE_CHARGE_DOCS_URL_MAP[order.cost.version];

  return (
    <div>
      <h3>
        Volume Band and Service Package
      </h3>

      <div className="margin-bottom-sm">
        Please note that you can only pick the silver package if you receive more than 3,650 GiB per year.
        Similarly, you can only pick the gold package if you receive more than 18,250 GiB per year.
      </div>

      <div>
        <ServicePackagePicker
          order={order}
          volumeBand={volumeBand}
          serviceCharges={serviceCharges}
          servicePackages={servicePackages}
          onChange={onServicePackageChange}
          value={orderServicePackage}
        />
        <FormError message={formik.errors.service_package_id}
                   when={formik.touched.service_package_id && Boolean(formik.errors.service_package_id)} />
      </div>

      {
        docs &&
        <div className="margin-top-md">
          For more information about the service packages and the services included, please refer to our page
          &thinsp;
          <ExternalLink url={docs.url}>
            ECMWF service charge model for real-time data: {docs.title}
          </ExternalLink>.
        </div>
      }
    </div>
  )
}

export default ServicePackageStep;
